import React from "react";
import { StyledCollaboratorProfileCard } from "./CollaboratorProfileCard.styled";
import { Divider } from "../core/Divider/Divider";

interface CollaboratorProfileCardProps {
  content: React.ReactNode;
  bottomContent?: React.ReactNode;
}

export const CollaboratorProfileCard = ({
  content,
  bottomContent,
}: CollaboratorProfileCardProps) => {
  return (
    <StyledCollaboratorProfileCard>
      <div className="top-content">{content}</div>
      {bottomContent && <Divider />}
      {bottomContent && <div className="bottom-content">{bottomContent}</div>}
    </StyledCollaboratorProfileCard>
  );
};
